import searchWatcher from './Auth/authSaga'
import { all } from '@redux-saga/core/effects'
import orderStatusWorker from './OrderStatus/orderStatusSaga'
import menuWatcher from './Menu/menuSaga'

export default function* rootSaga() {
  yield all([searchWatcher(), orderStatusWorker(), menuWatcher()])
}
